import React, { useEffect, useState } from "react";
import "./Plan_Purchase_step_two.css";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { RegxExpression } from "../../../../../utils/common";
import { Controller } from "react-hook-form";
import { getData } from "../../../../../utils/api";

function Plan_Purchase_step_two({
  onSubmit,
  setShowModal,
  control,
  handleSubmit,
  register,
  errors,
}) {
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const [nationality, setNationality] = useState([]);
  const GetAllNationality = async () => {
    const response = await getData("/without-login/master/all-nationality");

    const option = [];
    if (response.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "nationality_id",
          label: data.name,
        });
      });
    }
    setNationality(option);
  };

  useEffect(() => {
    GetAllNationality();
  }, []);
  return (
    <>
      <section className="tab_form_holder">
        <Form >
          <Form.Group className="field_holder" controlId="formBasicEmail">
            <Form.Label>Pincode (of current residential address)</Form.Label>
         
            <Form.Control
              type="text"
              name="pincode"
             placeholder="Enter your area pincode"
              {...register("pincode", {
                required: "Name is required",
              })}
              onKeyDown={(event) => {
                if (!RegxExpression.name.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
            {errors?.pincode && (
              <span className="invalid-feedback d-block">
                {errors.pincode.message}
              </span>
            )}
          </Form.Group>

          <Form.Group className="field_holder" controlId="formBasicEmail">
            <Form.Label>City (of current residential address)</Form.Label>
        
            <Form.Control
              type="text"
              name="city"
              placeholder="Enter City"
              {...register("city", {
                required: "City is required",
              })}
              onKeyDown={(event) => {
                if (!RegxExpression.name.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
            {errors?.city && (
              <span className="invalid-feedback d-block">
                {errors.city.message}
              </span>
            )}
          </Form.Group>

          <Form.Group className="field_holder" controlId="formBasicEmail">
            <Form.Label>Nationality</Form.Label>
          
            <Controller
              name="nationality_id"
              control={control}
              rules={{ required: "Nationality is required" }} 
              render={({ field }) => (
                <Select
                  {...field}
                  options={nationality}
                  placeholder="Choose Nationality"
                />
              )}
            />
            {errors?.nationality_id && (
              <span className="invalid-feedback d-block">
                {errors.nationality_id.message}
              </span>
            )}
          </Form.Group>
        </Form>
      </section>
    </>
  );
}

export default Plan_Purchase_step_two;
